var SupportTaglineHelper;

SupportTaglineHelper = {
  create: function() {
    var memo, ref, tagLine;
    if ((ref = Groupon.Support.currentOrder) != null ? ref.tagLine : void 0) {
      if (Groupon.Support.ABOUT_AN_ORDER === true) {
        return Groupon.Support.currentOrder.tagLine + ",about_an_order";
      } else {
        return Groupon.Support.currentOrder.tagLine;
      }
    }
    tagLine = {};
    memo = "";
    if (typeof currentUser === "undefined" || currentUser === null) {
      tagLine.userState = "not_signed_in";
    }
    if (Groupon.Support.ORDER_NOT_LISTED === true) {
      tagLine.orderNotListed = "order_not_listed";
    }
    if (Groupon.Support.NOT_ORDER_RELATED === true) {
      tagLine.notOrderRelated = "not_order_related";
    }
    if (Groupon.Support.ACCOUNT_RELATED === true) {
      tagLine.accountRelated = "account_related";
    }
    if (Groupon.Support.PRE_PURCHASE === true) {
      tagLine.prePurchase = "making_a_purchase";
    }
    if (Groupon.Support.SOMETHING_ELSE === true) {
      tagLine.others = "something_else";
    }
    if (!_.isEmpty(tagLine)) {
      return _.reduce(tagLine, (function(_this) {
        return function(memo, tag) {
          return memo + "," + tag;
        };
      })(this));
    } else {
      return "";
    }
  }
};

module.exports = SupportTaglineHelper;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvaGVscGVycy9UYWdsaW5lLmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi92YXIvZ3JvdXBvbi9ob21lL3JtdXJ1Z2FuL25hcGlzdHJhbm8vYnVpbGQvMTUwMTc4MjAxNjMwNi01OTQzNS9wcm9kdWN0aW9uLTIwMTcuMDguMDNfMTcuMzYvc3VwcG9ydF9hcHAvbW9kdWxlcy9zdXBwb3J0L2Zyb250ZW5kL2hlbHBlcnMvVGFnbGluZS5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQ0EsSUFBQTs7QUFBQSxvQkFBQSxHQUNFO0VBQUEsTUFBQSxFQUFRLFNBQUE7QUFDTixRQUFBO0lBQUEsc0RBQStCLENBQUUsZ0JBQWpDO01BQ0UsSUFBRyxPQUFPLENBQUMsT0FBTyxDQUFDLGNBQWhCLEtBQWtDLElBQXJDO0FBQ0UsZUFBVSxPQUFPLENBQUMsT0FBTyxDQUFDLFlBQVksQ0FBQyxPQUE5QixHQUFzQyxrQkFEakQ7T0FBQSxNQUFBO0FBR0UsZUFBTyxPQUFPLENBQUMsT0FBTyxDQUFDLFlBQVksQ0FBQyxRQUh0QztPQURGOztJQU1BLE9BQUEsR0FBVTtJQUNWLElBQUEsR0FBTztJQUNQLElBQTJDLDBEQUEzQztNQUFBLE9BQU8sQ0FBQyxTQUFSLEdBQW9CLGdCQUFwQjs7SUFDQSxJQUErQyxPQUFPLENBQUMsT0FBTyxDQUFDLGdCQUFoQixLQUFvQyxJQUFuRjtNQUFBLE9BQU8sQ0FBQyxjQUFSLEdBQXlCLG1CQUF6Qjs7SUFDQSxJQUFpRCxPQUFPLENBQUMsT0FBTyxDQUFDLGlCQUFoQixLQUFxQyxJQUF0RjtNQUFBLE9BQU8sQ0FBQyxlQUFSLEdBQTBCLG9CQUExQjs7SUFDQSxJQUE4QyxPQUFPLENBQUMsT0FBTyxDQUFDLGVBQWhCLEtBQW1DLElBQWpGO01BQUEsT0FBTyxDQUFDLGNBQVIsR0FBeUIsa0JBQXpCOztJQUNBLElBQTZDLE9BQU8sQ0FBQyxPQUFPLENBQUMsWUFBaEIsS0FBZ0MsSUFBN0U7TUFBQSxPQUFPLENBQUMsV0FBUixHQUFzQixvQkFBdEI7O0lBQ0EsSUFBcUMsT0FBTyxDQUFDLE9BQU8sQ0FBQyxjQUFoQixLQUFrQyxJQUF2RTtNQUFBLE9BQU8sQ0FBQyxNQUFSLEdBQWlCLGlCQUFqQjs7SUFDQSxJQUFBLENBQU8sQ0FBQyxDQUFDLE9BQUYsQ0FBVSxPQUFWLENBQVA7QUFDSSxhQUFPLENBQUMsQ0FBQyxNQUFGLENBQVMsT0FBVCxFQUFrQixDQUFBLFNBQUEsS0FBQTtlQUFBLFNBQUMsSUFBRCxFQUFPLEdBQVA7aUJBQWtCLElBQUQsR0FBTSxHQUFOLEdBQVM7UUFBMUI7TUFBQSxDQUFBLENBQUEsQ0FBQSxJQUFBLENBQWxCLEVBRFg7S0FBQSxNQUFBO0FBR0ksYUFBTyxHQUhYOztFQWZNLENBQVI7OztBQW9CRixNQUFNLENBQUMsT0FBUCxHQUFpQiJ9
